var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('HomeHero'),_c('HomeAbout'),_c('HomeIppan'),_c('HomeSinryou'),_c('HomeOrder'),_c('go-top',{attrs:{"max-width":"50","bg-color":"#0097A7","size":50}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }